import { combineReducers } from 'redux';

import { transactionConstants } from '../constants';
import {
  StripeCoupon,
  V1Coupon,
} from '../py-generated/datalouder/checkout/types';

interface PriceStates {
  loading?: boolean;
  PRICE_PER_MONTH?: number;
  DISCOUNT_FOR_12_MONTH?: number;
  error?: Error;
}

const prices = (state: PriceStates = {}, action): PriceStates => {
  switch (action.type) {
    case transactionConstants.GET_PRICE_REQUEST: {
      return {
        loading: true,
      };
    }
    case transactionConstants.GET_PRICE_SUCCESS: {
      return {
        PRICE_PER_MONTH: action.prices.PRICE_PER_MONTH,
        DISCOUNT_FOR_12_MONTH: action.prices.DISCOUNT_FOR_12_MONTH,
      };
    }
    case transactionConstants.GET_PRICE_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

interface PromoStates {
  code?: string;
  loading?: boolean;
  promo?: V1Coupon;
  stripeCoupon?: StripeCoupon;
  error?: Error;
}

const promo = (
  state: PromoStates = { code: undefined },
  action
): PromoStates => {
  switch (action.type) {
    case transactionConstants.GET_PROMO_REQUEST: {
      return {
        loading: true,
        code: action.code,
      };
    }
    case transactionConstants.GET_PROMO_SUCCESS: {
      return {
        code: state.code,
        promo: action.promo,
        stripeCoupon: action.stripeCoupon,
      };
    }
    case transactionConstants.GET_PROMO_FAILURE: {
      return {
        error: action.error,
      };
    }
    case transactionConstants.GET_PROMO_CLEAR: {
      return {};
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  prices,
  promo,
});
